import {OptimizationSpecialistAreaDashboard} from '@features/optimization-specialist-dashboard'
import {useRouteSegmentsAreaNavigation} from '@widgets/area-dashboard'

import {LocationBreadcrumbs} from '../../components'
import {useHrocMapMarkersData} from '../../hooks'
import {AREA_ROUTE_SEGMENTS, OPTIMIZATION_SPECIALIST_DASHBOARD} from '../../routing'

export const AreaOptimizationSpecialistDashboard = () => (
  <OptimizationSpecialistAreaDashboard
    dashboardRoute={OPTIMIZATION_SPECIALIST_DASHBOARD}
    navigation={useRouteSegmentsAreaNavigation(AREA_ROUTE_SEGMENTS)}
    fallbackBreadcrumbs={<LocationBreadcrumbs sx={{ml: 0}} />}
    useMapMarkersDataHook={useHrocMapMarkersData}
  />
)
